import { useSelector } from 'react-redux';
import { appDistributionSelector, distributionMapSelector } from '@store/common/selectors';
import { isAppModule } from '@utils/constants';

function useCheckIfDistributionIsEnabled(metric) {
  const distributionMetrics = useSelector(distributionMapSelector);
  const appDistributionEnabled = useSelector(appDistributionSelector);
  if (isAppModule && !appDistributionEnabled) {
    return false;
  }
  /** enabled when distribution config is array with at least one element */
  return (
    metric in distributionMetrics &&
    Array.isArray(distributionMetrics[metric]) &&
    distributionMetrics[metric].length > 0
  );
}

export default useCheckIfDistributionIsEnabled;
